<template>
		<li class="c-available-now__item">
			<span class="c-available-now__count">{{count}}</span>
			<span class="c-available-now__text">{{heading}}</span>
		</li>
</template>

<script>
import VIcon from "../icon/VIcon.vue";

export default {
	name: "VAvailableNowBlockItem",
	components: {
		VIcon
	},
	props: {
		count: { type: String },
		heading: { type: String }
	}
};
</script>
